var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"y-chat-window"},_vm._l((_vm.messages),function(message){return _c('chat-message-item',{key:message.id,class:{'is_me': message.from == _vm.student.id},attrs:{"message":message},on:{"editMessage":function($event){return _vm.editMessage($event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }